import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Meet from "./components/about/Meet";
import BeforeAfter from "./components/about/BeforeAfter";
import FAQ from "./components/about/FAQ";
import Blog from "./components/about/Blog";
import DentalTechnology from "./components/about/DentalTechnology";
import NewPatient from "./components/newpatient/NewPatient";
import Problem from "./components/service/Problem";
import Invisalign from "./components/service/Invisalign";
import Surgical from "./components/service/Surgical";
import Braces from "./components/service/Braces";
import PatientComfort from "./components/newpatient/PatientComfort";
import FreeConsultation from "./components/newpatient/FreeConsultation";
import BlogDetail from "./components/about/BlogDetail";
import BracesDetail from "./components/service/BracesDetail";
import BookForm from "./components/book_now/BookForm";
import CreateBlog from "./components/admin/CreateBlog";
import Login from "./components/admin/Login";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import EditBlog from "./components/admin/EditBlog";
import ViewEmails from "./components/admin/ViewEmails";
import Admin from "./components/admin/Admin";
import TopBar from "./components/admin/TopBar";
import { HeadingProvider } from "./components/admin/HeadingContext";
import TermsandCondition from "./components/footer/TermsandCondition";
import PrivacyPolicy from "./components/footer/PrivacyPolicy";
import BlogDetails from "./components/about/BlogDetails";
import MarketingPage from "./components/Marketing/MaerkingPage";
import ThankYouPage from "./components/Marketing/ThankYouPage";

// Create a layout component that conditionally renders Navbar and Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isMarketingPage = location.pathname === "/promotion";

  return (
    <>
      {!isMarketingPage && <Navbar />}
      {children}
      {!isMarketingPage && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <HeadingProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy-policies" element={<PrivacyPolicy />} />
            <Route
              path="/term-and-conditions"
              element={<TermsandCondition />}
            />
            <Route path="/meet-the-doctors" element={<Meet />} />
            <Route path="/beforeafter" element={<BeforeAfter />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blogs/:id" element={<BlogDetails />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/dentaltech" element={<DentalTechnology />} />
            <Route path="/problem" element={<Problem />} />
            <Route path="/invisalign" element={<Invisalign />} />
            <Route path="/braces" element={<Braces />} />
            <Route path="/braces/:id" element={<BracesDetail />} />
            <Route path="/surgical" element={<Surgical />} />
            <Route path="/newpatient" element={<NewPatient />} />
            <Route path="/patientcomfort" element={<PatientComfort />} />
            <Route path="/freeconsultation" element={<FreeConsultation />} />
            <Route path="/booknow" element={<BookForm />} />
            <Route path="/" element={<Blog blogs={[]} />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/promotion" element={<MarketingPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/create-blog"
              element={
                <ProtectedRoute>
                  <CreateBlog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/edit-blog"
              element={
                <ProtectedRoute>
                  <EditBlog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/view-emails"
              element={
                <ProtectedRoute>
                  <ViewEmails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/topbar"
              element={
                <ProtectedRoute>
                  <TopBar />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
      </HeadingProvider>
    </Router>
  );
}

export default App;
